<stages-dialog2 #dialog class="autoHeight">
	<stages-dialog-header />
	@if (task$ | async; as task) {
		<div class="content">
			<h1>{{ task.name }}</h1>
			<form [formGroup]="form" class="form">
				@if (!task.actions.ClaimTask) {
					<div class="form-group">
						<div class="input-container sm" [ngClass]="{ required: task.commentRequired }">
							<label for="comment" class="input-label" translate="dashboard.todolist.task.comment"></label>
							<textarea
								id="comment"
								name="comment"
								rows="0"
								tabindex="1"
								formControlName="comment"
								stagesAutoGrow
								stagesTrim
								stagesAutofocus
								class="text plaintext-input"
							></textarea>
							<div class="info">
								@if (form.get("comment")!.errors && (form.get("comment")!.dirty || form.get("comment")!.touched)) {
									<div>
										@if (form.get("comment")!.errors?.required) {
											<div class="error" translate="input.required" role="alert"></div>
										}
									</div>
								}
							</div>
						</div>
					</div>
					<div class="form-group">
						<div class="input-container sm">
							@if (dateTimeInput) {
								<stages-input [form]="form" [input]="dateTimeInput"></stages-input>
							}
						</div>
					</div>
				}
				@if (task.description.html !== "") {
					<div class="form-group">
						<div class="input-container">
							<label
								for="todolist-task-description"
								class="input-label"
								translate="dashboard.todolist.task.description"
							></label>
							<stages-description-view id="todolist-task-description" #description [html]="task.description.html">
							</stages-description-view>
							<div class="info"></div>
						</div>
					</div>
				}
				@if (task.versionDescription!.html !== "") {
					<div class="form-group">
						<div class="input-container">
							<label
								for="todolist-task-versiondescription"
								class="input-label"
								translate="dashboard.todolist.task.versionDescription"
							></label>
							<stages-description-view
								id="todolist-task-versiondescription"
								#description
								[html]="task.versionDescription!.html"
							>
							</stages-description-view>
							<div class="info"></div>
						</div>
					</div>
				}
				<div class="form-group">
					<div class="input-container sm">
						<label for="todolist-task-process" class="input-label" translate="dashboard.todolist.task.process"></label>
						<ul id="todolist-task-process" class="list dense">
							<li class="list-item no-hover no-padding">
								<div class="label">
									<div class="text">
										<h4 translate="dashboard.todolist.task.versionName"></h4>
										<p>{{ task.versionName }}</p>
									</div>
								</div>
							</li>
							<li class="list-item no-hover no-padding">
								<div class="label">
									<div class="text">
										<h4 translate="dashboard.todolist.task.workspaceName"></h4>
										<p>{{ task.workspaceName }}</p>
									</div>
								</div>
							</li>
							<li class="list-item no-hover no-padding">
								<div class="label">
									<div class="text">
										<h4 translate="dashboard.todolist.task.workspacePath"></h4>
										<p>{{ task.workspacePath }}</p>
									</div>
								</div>
							</li>
						</ul>
						<div class="info"></div>
					</div>
					<div class="input-container sm">
						<h5 class="input-label" translate="dashboard.todolist.task.details"></h5>
						<ul class="list dense">
							<li class="list-item no-hover no-padding">
								<div class="label">
									<div class="text">
										<h4 translate="dashboard.todolist.task.state"></h4>
										<p>
											<span
												class="badge changed-badge"
												[ngClass]="task.state"
												[translate]="'dashboard.todolist.task.state.' + task.state"
											></span>
										</p>
									</div>
								</div>
							</li>
							<li class="list-item no-hover no-padding">
								<div class="label">
									<div class="text">
										<h4 translate="dashboard.todolist.task.creationDate"></h4>
										<p>{{ task.creationDate }}</p>
									</div>
								</div>
							</li>
							@if (!!task.dueDate) {
								<li class="list-item no-hover no-padding">
									<div class="label">
										<div class="text">
											<h4 translate="dashboard.todolist.task.dueDate"></h4>
											<p>{{ task.dueDate }}</p>
										</div>
									</div>
								</li>
							}
							<li class="list-item no-hover no-padding">
								<div class="label">
									<div class="text">
										<h4 translate="dashboard.todolist.task.workflowName"></h4>
										<p>{{ task.workflowName }}</p>
									</div>
								</div>
							</li>
						</ul>
						<div class="info"></div>
					</div>
				</div>
			</form>
			@if (task.stepType == "APPROVE_PROCESS_INTERFACES" && task.actions["ReadInterfaces"]) {
				<div class="contentpadding">
					<h5 class="input-label" translate="dashboard.todolist.task.changes"></h5>
				</div>
				<stages-process-interfaces-interfaces-list
					[sourceWorkspaceId]="task.workspaceId"
					[sourceProcessVersion]="task.versionIdentifier"
					[targetWorkspaceId]="task.workflowInstanceWorkspaceId"
					[showOnlyChanges]="true"
					[routable]="false"
				></stages-process-interfaces-interfaces-list>
				<div class="form">
					<div class="form-group">
						<div class="input-container sm">
							<div class="info"></div>
						</div>
					</div>
				</div>
			}
			<div class="contentpadding">
				<h5 class="input-label" translate="dashboard.todolist.task.workflowInitiator"></h5>
			</div>
			<ul class="list">
				<li class="list-item">
					<div class="label">
						<div class="avatar-cell">
							<stages-user-image
								[userName]="task.workflowInitiator.name"
								userId="{{ task.workflowInitiator.id }}"
								version="{{ task.workflowInitiator.profileImageVersion }}"
							></stages-user-image>
						</div>
						<div class="text center">
							<h4>{{ task.workflowInitiator.fullname }}</h4>
							<p>{{ task.workflowInitiator.emailAddress }}</p>
						</div>
					</div>
				</li>
			</ul>
			@if (task.relatedTasks.length > 0) {
				<div class="contentpadding">
					<h5 class="input-label" translate="dashboard.todolist.task.related"></h5>
				</div>
				<ul class="list">
					@for (relatedTask of task.relatedTasks; track trackBy($index, relatedTask); let last = $last) {
						<li class="list-item">
							<div class="label">
								<div class="avatar-cell">
									@if (relatedTask.user) {
										<stages-user-image
											[userName]="relatedTask.user.name"
											userId="{{ relatedTask.user.id }}"
											version="{{ relatedTask.user.profileImageVersion }}"
										></stages-user-image>
									}
									@if (!relatedTask.user) {
										<img
											class="avatar"
											[attr.alt]="'accessibility.profilepicture.group.placeholder' | translate"
											src="img/image/avatar/group.png"
										/>
									}
								</div>
								<div class="text center">
									<h4>
										{{ relatedTask.name }}
										<span
											class="badge changed-badge"
											[ngClass]="relatedTask.state"
											[translate]="getStateKey(relatedTask)"
										></span>
									</h4>
									@if (relatedTask.user) {
										<p>{{ relatedTask.user.fullname }}</p>
									}
									<p>
										<span>{{ relatedTask.completionDate }}</span>
										@if (!!relatedTask.decision) {
											<span>
												-
												<span
													class="decision"
													[ngStyle]="{
														'background-color': relatedTask.decision.color,
														color: relatedTask.decision.textColor,
													}"
												>
													{{ relatedTask.decision.name }}
												</span></span
											>
										}
									</p>
									@if (relatedTask.comment !== null) {
										<p>{{ relatedTask.comment }}</p>
									}
								</div>
							</div>
						</li>
						@if (!last) {
							<li class="divider"></li>
						}
					}
				</ul>
			}
		</div>
		<footer>
			<stages-buttons-bottom [removeBoundaries]="true">
				<button type="button" class="button flat" translate="cancel" (click)="cancel()" tabindex="2"></button>
				@if (!!task.actions.ClaimTask) {
					<button
						type="button"
						class="button sm action"
						(click)="claimTask(task)"
						tabindex="3"
						translate="management.process.versions.workflows.task.claim"
					></button>
				}
				@if (!task.actions.ClaimTask) {
					@for (option of task.options; track option; let index = $index) {
						<button
							type="button"
							class="button sm action"
							(click)="completeTask(task, option.id!)"
							[disabled]="!this.form.valid"
							[ngStyle]="{
								'background-color': this.form.valid ? option.color : null,
								color: this.form.valid ? option.textColor : null,
							}"
							tabindex="{{ 3 + index }}"
						>
							{{ option.name }}
						</button>
					}
				}
			</stages-buttons-bottom>
		</footer>
	}
</stages-dialog2>
